import { render, staticRenderFns } from "./ClassRelationHexagonal.vue?vue&type=template&id=b2428ebe&scoped=true&"
import script from "./ClassRelationHexagonal.vue?vue&type=script&lang=js&"
export * from "./ClassRelationHexagonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2428ebe",
  null
  
)

export default component.exports